import React, { useState, useRef, useEffect } from 'react';
import './Topbar.css';
import { User, LogOut, Settings } from 'lucide-react';

const Topbar = ({ setMenuAberto, titulo, botao=false }) => {
  const [submenuAberto, setSubmenuAberto] = useState(false);
  const avatarRef = useRef(null);

  // Fecha o submenu ao clicar fora
  useEffect(() => {
    function handleClickOutside(event) {
      if (avatarRef.current && !avatarRef.current.contains(event.target)) {
        setSubmenuAberto(false);
      }
    }
    if (submenuAberto) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [submenuAberto]);

  return (
    <header className="topbar">
      <div className="topbar-left">
        <button className="btn-menu" onClick={() => setMenuAberto(true)}>
          <span className="menu-icon">☰</span>
        </button>
        <h2>{titulo}</h2>
      </div>
      <div className="topbar-actions">
        {/* {botao} */}
        <div className="avatar" ref={avatarRef} onClick={() => setSubmenuAberto(v => !v)} style={{cursor: 'pointer', position: 'relative', background: 'linear-gradient(135deg, #e0e7ff 0%, #f0fdfa 100%)', boxShadow: '0 2px 8px rgba(37,99,235,0.08)'}}>
          <User size={28} color="#2563eb" strokeWidth={2.2} />
          {submenuAberto && (
            <div className="avatar-submenu">
              {/* <button className="avatar-submenu-item">
                <Settings size={18} style={{marginRight: 10}} /> Configurações
              </button> */}
              <button className="avatar-submenu-item sair">
                <LogOut size={18} style={{marginRight: 10}} /> Sair do sistema
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Topbar; 